/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, {
  useState,
  useEffect,
  useCallback,
  useMemo
} from "react";
import PropTypes from "prop-types";
import { generatePath, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";
import useConfig from "app/hooks/useConfig";
import { Button, Image, Modal1, Trigger, TriggerInfo } from "app/components";
// import { getReactElement } from '../utils';
import { useModal } from "app/hooks";
import {
  FamilyFilmClubWrapper,
  FamilyFilmClubContent,
  Expander,
  Toast
} from "./styles";

const propTypes = {
  content: PropTypes.string,
  fetchContent: PropTypes.func.isRequired,
  user: PropTypes.shape({
    memberLevelId: PropTypes.string
  }).isRequired
};

const defaultProps = {
  content: null
};

const FamilyFilmClub = ({ content, fetchContent, user }) => {
  const [t, i18n] = useTranslation();
  const { routes } = useConfig();
  const [token, setToken] = useState();

  useEffect(() => {
    const tkn = localStorage.getItem("accessToken");

    setToken(tkn);
  }, [token, user?.memberLevelId]);

  const [
    streamingFunction,
    showStreamingFunction,
    hideStreamingFunction
  ] = useModal("streamingFunction");

  const [toast, setToast] = useState(false);
  const showToast = () => {
    setToast(true);
    setTimeout(() => { setToast(false) }, 4000);
  };

  useEffect(() => {
    if(process.env.REACT_APP_COUNTRY === "svn"){
      document.title = "Cineplexx | Družinski filmski klub"
    }

    return () => {
      document.title = "Cineplexx"
    };
  }, [])

  const [familyFilmClubContent, setFamilyFilmClubContent] = useState({
    picture: "",
    description: "",
    registrationLink: "",
    description1: "",
    faq: {
      headline: "",
      faqData: [
        {
          title: "",
          description: "",
          picture2: ""
        }
      ]
    },
    information: {
      descriptionInfo: "",
      linkedEvent: null
    },
    celebrate: {
      description: "",
      picture: "",
      description2: ""
    }
  });
  const [isExpanded, setIsExpanded] = useState([]);

  useEffect(() => {
    fetchContent();

    // return () => clearState();
  }, [i18n.language]);

  useEffect(() => {
    if (content?.length > 0) {
      // divRef.current = getReactElement(content);
      // setLoaded(true);
      const {
        picture,
        PictureEN,
        description,
        descriptionEN,
        registrationLink,
        description1,
        description1EN,
        faq,
        information,
        celebrate
      } = content[0];

      setFamilyFilmClubContent({
        picture: i18n.language === "en" || i18n.language === 'en-US' ? PictureEN : picture,
        description: i18n.language === "en" || i18n.language === 'en-US' ? descriptionEN : description,
        registrationLink,
        description1: i18n.language === "en" || i18n.language === 'en-US' ? description1EN : description1,
        faq,
        information,
        celebrate
      });
    }
  }, [content]);

  const setExpandCb = useCallback(
    id => {
      const expandList = [...isExpanded];

      if (expandList.includes(id)) {
        expandList.splice(expandList.indexOf(id), 1);
      } else {
        expandList.push(id);
      }

      setIsExpanded(expandList);
    },
    [isExpanded]
  );

  const languageContents = useMemo(
    () => ({
      headline: i18n.language === "en" || i18n.language === 'en-US' ? "headlineEN" : "headline",
      title: i18n.language === "en" || i18n.language === 'en-US' ? "titleEN" : "title",
      title1: i18n.language === "en" || i18n.language === 'en-US' ? "title_en" : "title",
      description: i18n.language === "en" || i18n.language === 'en-US' ? "descriptionEN" : "description",
      descriptionInfo:
        i18n.language === "en" || i18n.language === 'en-US' ? "descriptionInfoEN" : "descriptionInfo",
      description2: i18n.language === "en" || i18n.language === 'en-US' ? "description2EN" : "description2"
    }),
    [i18n.language]
  );

  useEffect(() => {
    localStorage.removeItem("eventId");
    localStorage.removeItem("selectMovieId");
    sessionStorage.removeItem("movie");
    sessionStorage.removeItem('cinemaId');
    localStorage.removeItem("searchMovieId");
  }, [])

  return (
    <FamilyFilmClubWrapper>
      {toast && (
        <Toast>
          <div className="toast">{t("info.family_film_club_toast")}</div>
        </Toast>
      )}
      {content?.length > 0 && familyFilmClubContent?.picture && (
        <>
          <h1 className="family-film-club__title">
            {t("common.family_film_club")}
          </h1>
          <Modal1 isOpen={streamingFunction} close={hideStreamingFunction}>
            <h4>{t("info.family_film_club_popup")}</h4>
          </Modal1>
          <FamilyFilmClubContent>
            <div className="family-film-club__container">
              <div className="family-film-club__image-wrapper">
                <Image src={familyFilmClubContent?.picture} />
              </div>
              <div className="family-film-club__description-wrapper">
                {parse(familyFilmClubContent?.description)}
              </div>

              <div className="family-film-club__registration-wrapper">
                {token == null || user?.memberLevelId === 1 ? (
                  <NavLink
                    className="l-sublist__link"
                    to={{
                      pathname: generatePath(routes.ffcSignUp.pattern)
                    }}
                    activeClassName="_active"
                  >
                    <Button
                      type="button"
                      isPrimary
                      className="family-film-club__registration-btn"
                    >
                      {t("common.join_now")}
                    </Button>
                  </NavLink>
                ) : (
                  <Button
                    type="button"
                    isPrimary
                    className="family-film-club__registration-btn"
                    onClick={
                      user?.memberLevelId === 4
                        ? showToast
                        : showStreamingFunction
                    }
                  >
                    {t("common.join_now")}
                  </Button>
                )}
              </div>

              <div className="family-film-club__description1-wrapper">
                {parse(familyFilmClubContent?.description1)}
              </div>
              <div className="family-film-club__faq-wrapper">
                <h3>
                  {familyFilmClubContent?.faq?.[languageContents.headline]}
                </h3>
                {familyFilmClubContent?.faq?.faqData?.map((item, index) => (
                  <div key={item?.title} className="family-film-club__faq-item">
                    <TriggerInfo
                      isExpanded={isExpanded.includes(index)}
                      onClick={() => setExpandCb(index)}>
                      <div className="family-film-club__faq-item-wrapper">
                        <h3>{item?.[languageContents.title]}</h3>
                        <Trigger
                          className="family-film-club__faq-content-accordion"
                          isExpanded={isExpanded.includes(index)}
                          onClick={() => setExpandCb(index)}
                        >
                          <span className="_with-chevron" />
                        </Trigger>
                      </div>
                    </TriggerInfo>
                    <Expander isExpanded={isExpanded.includes(index)}>
                      <div className="family-film-club__faq-item-expand-content">
                        {parse(item?.[languageContents.description])}
                      </div>
                    </Expander>
                  </div>
                ))}
              </div>
              <div className="family-film-club__information-wrapper">
                <div>
                  {parse(familyFilmClubContent?.information?.descriptionInfo)}
                </div>
                {familyFilmClubContent?.information?.linkedEvent?.[languageContents.title1] ?
                  <NavLink
                    to={{
                      pathname: generatePath(routes.eventDetails.pattern, {
                        id: familyFilmClubContent?.information?.linkedEvent?.[languageContents.title1]?.replaceAll(" ", "-")
                      }),
                      state: {
                        eventId:
                          familyFilmClubContent?.information?.linkedEvent?.id
                      }
                    }}
                  >
                    <Button isPrimary className="family-film-club__more-info-btn" onClick={() => sessionStorage.setItem("seletEventMovieId", familyFilmClubContent?.information?.linkedEvent?.id)} >
                      {t("common.more_information")}
                    </Button>
                  </NavLink>
                  :
                  <Button isPrimary className={`family-film-club__more-info-btn ${familyFilmClubContent?.information?.linkedEvent?.[languageContents.title1] ? " " : " disabled"}`}>
                    {t("common.more_information")}
                  </Button>
                }
              </div>
              <div className="family-film-club__celebrate-wrapper">
                <div>
                  {parse(
                    familyFilmClubContent?.celebrate?.[
                    languageContents.description
                    ]
                  )}
                </div>
                <div className="family-film-club__celebrate-image-wrapper">
                  <Image src={familyFilmClubContent?.celebrate?.picture} />
                </div>
                <div className="family-film-club__celebrate-description2-wrapper">
                  {parse(
                    familyFilmClubContent?.celebrate?.[
                    languageContents.description2
                    ]
                  )}
                </div>
              </div>
            </div>
          </FamilyFilmClubContent>
        </>
      )}
      {/* {!isLoading && !content && <h2 style={{ textAlign: 'center' }}>{t('common.coming_soon')}</h2>} */}
    </FamilyFilmClubWrapper>
  );
};

FamilyFilmClub.propTypes = propTypes;
FamilyFilmClub.defaultProps = defaultProps;

export default FamilyFilmClub;
